import { cityList, cityZipCodeList, cityZipList, StateList, stateList, zipCodeList } from "assets/geoData";
import { listItemProp } from "./types";
import { speedList, surfaceList } from "./constants";

export const randEnumValue = () => {
  enum MYENUM {
    "SUCCESS",
    "IN PROGRESS",
    "FAILED",
  }
  const enumValues = Object.values(MYENUM);
  const index = Math.floor(Math.random() * enumValues.length);
  let status = "default";
  if (enumValues[index] === "SUCCESS") {
    status = "success";
  } else if (enumValues[index] === "FAILED") {
    status = "primary";
  }
  let label = "IN PROGRESS";
  if (enumValues[index] === "SUCCESS") {
    label = "success";
  } else if (enumValues[index] === "FAILED") {
    label = "FAILED";
  }
  return { label, status };
};

export const aggMapping = (value: string) => {
  switch (value) {
    case "min_value":
      return "Minimum Value";
    case "max_value":
      return "Maximum Value";
    case "avg_value":
      return "Average";
    case "std_value":
      return "Standard deviation";
    default:
      return "Standard deviation";
  }
};

export const revAggMapping = (value: string) => {
  switch (value) {
    case "Minimum Value":
      return "min_value";
    case "Maximum Value":
      return "max_value";
    case "Average":
      return "avg_value";
    case "Standard deviation":
      return "std_value";
    default:
      return "std_value";
  }
};

export const attributesMapping = (value: string) => {
  switch (value) {
    case "vehicleName":
      return "Vehicle Name";
    case "modelYear":
      return "Model Year";
    case "dispatchModelType":
      return "Dispatch Model Type";
    case "state":
      return "States";
    default:
      return value;
  }
};

export const revAttributesMapping = (value: string) => {
  switch (value) {
    case "Vehicle Name":
      return "vehicleName";
    case "Model Year":
      return "modelYear";
    case "Dispatch Model Type":
      return "dispatchModelType";
    case "States":
      return "state";
    default:
      return value;
  }
};

export const calculatePercentileOfValue = (
  data: number[],
  value: number
): number => {
  // Step 1: Sort the array in ascending order
  const sortedData: number[] = [...data].sort((a, b) => a - b);

  // Step 2: Determine the rank of the given value
  const rank: number = sortedData.indexOf(value);
  const lastRank: number = sortedData.lastIndexOf(value);

  // Step 3: Calculate the percentile
  const n: number = sortedData.length;
  if (rank !== -1 && lastRank !== -1) {
    //percentile of first occurrance
    const percentile = parseFloat((((rank + 1) / (n + 1)) * 100).toFixed(2));
    //percentile of first occurrance
    const lastPercentile = parseFloat(
      (((lastRank + 1) / (n + 1)) * 100).toFixed(2)
    );
    // If the value is found in the array
    return parseFloat(
      (percentile + (lastPercentile - percentile) / 2).toFixed(2)
    );
  } else {
    // If the value is not found, interpolate between the percentiles of the nearest lower and higher ranks
    const lowerRank: number = sortedData.findIndex((val) => val > value) - 1;
    const higherRank: number = lowerRank + 1;
    const lowerValue: number = sortedData[lowerRank];
    const higherValue: number = sortedData[higherRank];
    const interpolatedRank: number =
      lowerRank + (value - lowerValue) / (higherValue - lowerValue);
    return parseFloat((((interpolatedRank + 1) / (n + 1)) * 100).toFixed(2));
  }
};

export const getHeaderValues = (header: string, data: any) => {
  let listData: any = [];
  data?.forEach((item: any) => {
    if (item[header] && !listData.includes(item[header]) && item[header]?.length > 0) {
      listData.push(item[header]);
    }
  });
  return listData;
};

export const getHeaderValuesFromArray = (header: string, data: any) => {
  let listData: any = [];
  data?.forEach((item: any) => {
    if (item[header]?.length > 0 && !listData.includes(item[header][0])) {
      listData.push(...item[header][0]);
    }
  });
  listData = listData?.filter(
    (item: string, index: number) => listData.indexOf(item) === index
  );
  return listData;
};

export const getHeaderSignalValuesFromArray = (header: string, data: any) => {
  let listData: any = [];
  data?.forEach((item: any) => {
    if(item[header]?.length > 0 ) {
      if (getSubDataType(item[header]) === 'array' && !listData.includes(item[header][0])) {
        listData.push(...item[header][0]);
      } else {
        listData= item[header]
      }
    } 
    if(item[header] && typeof item[header] === 'number') {
      listData.push(item[header])
    }
  });
  listData = listData?.filter(
    (item: string, index: number) => listData.indexOf(item) === index
  );
  return listData;
};

function getSubDataType(data: any) {
  let subDataType: string = '';
  if (Array.isArray(data)) {
    if(data?.length > 0) {
      data?.forEach(item => {
        if(typeof item === 'string') {
          subDataType = 'string';
        } 
        if(Array.isArray(item)) {
          subDataType = 'array'
        } 
      })
    }
  }
  return subDataType;
}

export const sortJobAuditList = (List: any) => {
  const newList = List?.map((obj: any) => {
    if (obj.requestDateAndTime) {
      return {
        ...obj,
        requestDateAndTime: new Date(obj?.requestDateAndTime)?.toISOString(),
      };
    }
    return obj;
  });
  newList.sort((a: any, b: any) =>
    b.requestDateAndTime.localeCompare(a.requestDateAndTime)
  );
  return newList;
};

export const sortAuditUserList = (List: any) => {
  const newList = List?.map((obj: any) => {
    if (obj.loginTime && new Date(obj?.loginTime)?.toString() !== "Invalid Date") {
      return {
        ...obj,
        loginTime: new Date(obj?.loginTime)?.toISOString(),
      };
    }
    return obj;
  });
  newList.sort((a: any, b: any) =>
    b.loginTime.localeCompare(a.loginTime)
  );
  return newList;
};

export const getNoOfItems = (List: any, listId: string) => {
  let newList: any = [];
  List?.forEach((item: any) => {
    if (!newList?.includes(item[listId])) {
      newList.push(item[listId]);
    }
  });
  return newList;
};

export const getBothSignalData = (canData: any, fiftyOneData: any) => {
  const mergedArray = canData
    ?.concat(fiftyOneData)
    .filter((value: string, index: number, self: any) => {
      return self.indexOf(value) === index;
    });
  return mergedArray;
};

export const getTimeStampFilterItem = (
  List: any,
  listId: string,
  lookUp: string
) => {
  const timeStamp: Array<string> = [];
  let updatedTimeStampList: any = [];
  List?.forEach((item: any) => {
    if(Array.isArray(item[listId]) && item[listId]?.length > 0) {
      timeStamp.push(item[listId][0]);
    } else {
      timeStamp.push(item[listId]);
    }
  });
  if (lookUp === "min") {
    updatedTimeStampList = timeStamp?.sort((a: any, b: any) =>
      a.localeCompare(b)
    );
  } else {
    updatedTimeStampList = timeStamp?.sort((a: any, b: any) =>
      b.localeCompare(a)
    );
  }
  const dateValue: any = new Date(updatedTimeStampList[0]);
  const result = new Intl.DateTimeFormat("en-US").format(dateValue);
  return result;
};

export const getBothAttributeData = (
  currentAttributes: any,
  canData: Array<string>,
  fiftyOneData: Array<string>
) => {
  const canAttribute: any = {
    title: "list_CanLabels",
    attributes: [],
  };

  const fiftyOneAttribute: any = {
    title: "list_51FLabels",
    attributes: [],
  };

  currentAttributes?.forEach((item: string) => {
    if (canData.includes(item)) {
      canAttribute.attributes.push(item);
    }
    if (fiftyOneData.includes(item)) {
      fiftyOneAttribute.attributes.push(item);
    }
  });

  const attributes: Array<any> = [];
  if (canAttribute?.attributes?.length > 0) attributes.push(canAttribute);
  if (fiftyOneAttribute?.attributes?.length > 0)
    attributes.push(fiftyOneAttribute);

  return attributes;
};

export const getSelectionValue = (list: listItemProp[], value: listItemProp) => {
  const dataList: any = [];
  if (list?.length > 0) {
    if (list.includes(value)) {
      const newss = list.filter((item: any) => item !== value);
      dataList.push(...newss);
    } else {
      dataList.push(...list);
      dataList.push(value);
    }
  } else {
    dataList.push(value);
  }
  return dataList;
};

export const receivedAllFourCoordinates = (value: any) => {
  return value?.filter((item: any) => item?.includes(null))?.length > 0
    ? false
    : true;
};

export const getLatLongList = (value: any) => {
  let latLong: any = {
    lat: [],
    long: [],
  };

  value?.forEach((item: string[]) => {
    latLong.lat.push(item[0]?.toString());
    latLong.long.push(item[1]?.toString());
  });
  return latLong;

};

export const autoCompleteSelectOptionsFormat = (list: string[]) => {
  let updatedList: listItemProp[] = []
  list?.forEach((element: string) => {
    if(element) {
      if (element?.length > 0 || typeof element === 'number') {
        updatedList.push({
          label: element,
          value: element
        })
      }
    }
  })
  console.log('upp', updatedList)
  return updatedList
}

export const selectedListValues = (list: listItemProp[]) => {
  let updatedList: string[] = []
  list?.forEach((element: listItemProp) => {
    updatedList.push(Array.isArray(element?.value) && element?.value?.length > 0 ? element?.value[0] : element.value)
  })
  return updatedList
}

export const checkAllMinMaxUpdated = (value: any) => {
  const dataElemnt: boolean[] = [];
  value?.forEach((element: any[]) => {
    dataElemnt.push(element[1]?.min?.length > 0 && element[1]?.max?.length > 0)
  });
  return dataElemnt.includes(false)
}

export const getJobType = (data: any) => {
  const subJobUserInput = data.replaceAll("'", '"');
  if (isJsonString(subJobUserInput)) {
    const jsonData = JSON.parse(subJobUserInput)
    const jobType = jsonData?.length > 0 && jsonData?.filter((item: any) => item?.title === 'job_type')[0]?.value;
    return jobType ? jobType : 'Un-Nested Data';
  } else {
    return 'Un-Nested Data'
  }

}

export const getJobName = (data: any) => {
  const subJobUserInput = data.replaceAll("'", '"');
  if (isJsonString(subJobUserInput)) {
    const jsonData = JSON.parse(subJobUserInput)
    const jobType = jsonData?.length > 0 && jsonData?.filter((item: any) => item?.title === 'job_name')[0]?.value;
    return jobType ? jobType : 'Un-Nested Job';
  } else {
    return 'Un-Nested Job'
  }

}

export const getSubJobType = (data: any) => {
  const subJobUserInput = data.replaceAll("'", '"');

  if (isJsonString(subJobUserInput)) {
    const jsonData = JSON.parse(subJobUserInput);
    const jobType = jsonData?.length > 0 && jsonData?.filter((item: any) => item?.title === 'job_type')[0]?.value;
    return jobType ? jobType : 'Data Fill / Fault';
  } else {
    return 'Data Fill / Fault'
  }
}

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const getListFromRawData = (list: any, header: string) => {
  let updatedList: string[] = []
  list?.forEach((element: any) => {
    if(element && element.hasOwnProperty(header) && element[header] && !updatedList.includes(element[header])) {
      updatedList.push(element[header])
    }
  })
  return updatedList
}

export const fomrattedTime = (newValue: any) => {
  const date = newValue.$d;
  const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;
  return formattedDate;
}

export const fomrattedTimeWithT = (newValue: any) => {
  const date = newValue?.$d;
  const formattedDate = `${date?.getFullYear()}-${(date?.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date?.getDate().toString().padStart(2, "0")}T${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date?.getMinutes().toString().padStart(2, "0")}:${date
        .getSeconds()
        .toString()
        .padStart(2, "0")}`;
  return formattedDate;
}

export const generateTimeSeriesData = (data: any) => {
  try {
    let dataValue = JSON.stringify(data);
    if (dataValue?.indexOf('NaN') >= 0) {
      dataValue = dataValue.replaceAll('NaN', '0');
      dataValue = JSON.parse(JSON.parse(dataValue))
      return dataValue;
    } else {
      return data
    }
  } catch (e) {
    console.log('errorr')
    return data;
  }
}

export const isDuplicate = (obj: any, array: any[]) => {
  return array.some(item => {
    return JSON.stringify(item) === JSON.stringify(obj);
  });
}

export const getAggreList = (data: string[]) => {
  let list: any[] = [];
  data?.forEach((item: string) => {
    if (item?.indexOf('_') > 0) {
      const aggValue = item?.split('_')[1];
      const element = {
        label: aggValue?.toUpperCase(),
        value: aggValue
      }
      if (!isDuplicate(element, list)) {
        list.push(element)
      }
    }
  })
  return list;
}

export const getAggreListHeatMap = (data: string[]) => {
  let list: any[] = [];
  data?.forEach((item: string) => {
    if (item?.length > 0) {
      const element = {
        label: item?.toUpperCase(),
        value: item
      }
      if (!list.includes(item)) {
        list.push(element)
      }
    }
  })
  return list;
}

export const getVinSelection = (data: string[]) => {
  const value: number[] = [];
  data?.forEach((el, index: number) => {
    if (index <= 3) {
      value.push(index)
    }
  })
  return value;
}

export const getVinSelectedData = (data: string[], selection: any[]) => {
  const value: string[] = [];
  data?.forEach((el, index: number) => {
    if (index <= 3 && selection[index]) {
      value.push(selection[index])
    }
  })
  return value;
}


export const getUserInputStringData = (data: any, key: string) => {
  const subJobUserInput = data.replaceAll("'", '"');
  if (isJsonString(subJobUserInput)) {
    const jsonData = JSON.parse(subJobUserInput)
    let jobType: string[] = [];
    jsonData?.forEach((item: any) => {
      if (item[key]) {
        jobType = item[key]
      }
    })
    return jobType?.length > 0 ? jobType : [];
  } else {
    return []
  }
}


export const getAggregateValue = (selectedAgg: string, list: any) => {
  let value: string = '';
  list?.forEach((element: any) => {
    if (element?.value === selectedAgg) {
      value = element?.label
    }
  })
  return value;
}

export const getVinListMapData = (data: any) => {
  const vinList: string[] = [];
  data?.available_attributes?.length > 0 && data?.available_attributes?.forEach((item: any) => {
    if (item?.vin?.length > 0 && !vinList?.includes(item['vin'])) {
      vinList.push(item['vin'])
    }
  })
  return vinList
}

export const getKeyData = (data: any[]) => {
  let cityList: any[] = [];
  let stateList: any[] = [];
  let zipcodeList: any[] = [];
  let countyList: any[] = [];
  data?.length > 0 && data?.forEach((element: any) => {
    if (element?.city_name?.length > 0 && !cityList.includes(element?.city_name)) cityList.push(element?.city_name);
    if (element?.state_name?.length > 0 && !stateList.includes(element?.state_name)) stateList.push(element?.state_name);
    if (element?.zip_code?.length > 0 && !zipcodeList.includes(element?.zip_code)) zipcodeList.push(element?.zip_code);
    if (element?.county_name?.length > 0 && !countyList.includes(element?.county_name)) countyList.push(element?.county_name);
  })
  return { cityList, stateList, zipcodeList, countyList }
}

export const getFilterKeyData = (data: any[]) => {
  let cityList: any[] = [];
  let stateList: any[] = [];
  let zipcodeList: any[] = [];
  data?.length > 0 && data?.forEach((element: any) => {
    if (element?.city_name?.length > 0 && !cityList.includes(element?.city_name)) cityList.push(element?.city_name);
    if (element?.state_name?.length > 0 && !stateList.includes(element?.state_name)) stateList.push(element?.state_name);
    if (element?.zip_code?.length > 0 && !zipcodeList.includes(element?.zip_code)) zipcodeList.push(element?.zip_code);
  })
  return { cityList, stateList, zipcodeList }
}

export const getSelectedStateKeyData = (data: any[], selection: any[]) => {
  let cityList: any[] = [];
  let zipcodeList: any[] = [];
  let countyList: any[] = [];
  selection?.forEach((element: string, index: number) => {
    if (element?.length > 0) {
      cityList = [];
      zipcodeList = [];
      countyList = [];
      data?.length > 0 && data?.forEach((item: any) => {
        if (index === 0 && item.state_name === element) {
          if (!cityList.includes(item?.city_name)) cityList.push(item?.city_name);
          if (!zipcodeList.includes(item?.zip_code)) zipcodeList.push(item?.zip_code);
          if (!countyList.includes(item?.county_name)) countyList.push(item?.county_name);
        } else if (index === 1 && item.city_name === element && item.state_name === selection[0]) {
          if (!cityList.includes(item?.city_name)) cityList.push(item?.city_name);
          if (!zipcodeList.includes(item?.zip_code)) zipcodeList.push(item?.zip_code);
          if (!countyList.includes(item?.county_name)) countyList.push(item?.county_name);
        } else if (index === 2 && item.county_name === element && item.state_name === selection[0]) {
          if (!cityList.includes(item?.city_name)) cityList.push(item?.city_name);
          if (!zipcodeList.includes(item?.zip_code)) zipcodeList.push(item?.zip_code);
          if (!countyList.includes(item?.county_name)) countyList.push(item?.county_name);
        }

      })
    }
  })
  return { cityList, zipcodeList, countyList }
}

export const getSelectedGeoLocationData = (data: any, selection: any) => {
  let selectionData: any[] = [];
  selection?.length > 0 && selection?.forEach((element: any) => {
    for (const [key, value] of Object.entries(element)) {
      data?.length > 0 && data?.forEach((item: any) => {
        if (item[key] === value && !selectionData.includes(item)) {
          selectionData.push(item)
        }
      })
    }
  })
  return selectionData;
}


export const getFilterSelectedGeoLocationData = (data: any, selection: any) => {
  let selectionData: any[] = [];
  selection?.length > 0 && selection?.forEach((element: any) => {
    for (const [key, value] of Object.entries<string[]>(element)) {
      data?.length > 0 && data?.forEach((item: any) => {
        if (value?.includes(item[key]) && !selectionData.includes(item)) {
          selectionData.push(item)
        }
      })
    }
  })
  return selectionData;
}

export const getQuadPlotData = (signalList: any[], sizeValue: number = 4) => {
  const list: any[] = [];
  for (let i = 0; i < signalList?.length; i += sizeValue) {
    list.push(signalList.slice(i, i + sizeValue));
  }

  return list
}

export const sliderMarkLabel = (lists: any) => {
  let marks: any = [];
  lists?.forEach((element: any) => {
    marks.push([
      {
        value: element[0],
        label: `${element[0]}`,
      },
      {
        value: element[1],
        label: `${element[1]}`,
      }
    ])
  })

  return marks;
}

export const getMaxValue = (list: any) => {
  const valueList: any[] = [];
  list?.forEach((dataList: any) => {
    if (dataList?.length === 1) {
      valueList.push(dataList[0])
    } else {
      const element = {
        Count: 0,
        CountPerc: 0,
        min: Object.values(dataList)?.reduce((min: any, item: any) => Math.min(min, item.min), Infinity),
        max: Object.values(dataList)?.reduce((min: any, item: any) => Math.max(min, item.max), 0),
      }
      valueList.push(element)
    }
  })
  return valueList;
}

export const updateMinMaxValue = (selectedList: any, list: any) => {
  let dataList: any = {};
  dataList = { ...list }

  Object.keys(selectedList)?.forEach((elemnt: string) => {
    let dataEleme: any = [];
    let dataSignal = list[elemnt];
    let userEntry = selectedList[elemnt];
    if (list?.hasOwnProperty(elemnt)) {

      dataSignal?.forEach((elemnent: any) => {
        if (Number(elemnent?.min) >= Number(userEntry?.min) && Number(elemnent?.max) <= Number(userEntry?.max)) {
          dataEleme.push(elemnent)
        }
      })
      if (dataEleme?.length > 0) {
        const totalCount = dataSignal?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0);
        const currentCount = dataEleme?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0)
        const outOfRangeCount = totalCount - currentCount;
        const element = {
          Count: outOfRangeCount,
          CountPerc: (outOfRangeCount / totalCount) * 100,
          min: dataEleme?.reduce((min: any, item: any) => Math.min(min, item.min), Infinity),
          max: dataEleme?.reduce((min: any, item: any) => Math.max(min, item?.max), 0),
        }
        dataList[elemnt] = [{ ...element }]
      } else {
        const totalCount = dataSignal?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0);
        const element = {
          Count: totalCount,
          CountPerc: 100,
          min: Number(userEntry?.min),
          max: Number(userEntry?.max),
        }
        dataList[elemnt] = [{ ...element }]
      }
      dataSignal = [];
      userEntry = [];
      dataEleme = []
    }
  })
  return dataList;
};

export const defaultMinMaxValue = (selectedList: any, list: any) => {
  let dataList: any = {};
  dataList = { ...list }

  Object.keys(selectedList)?.forEach((elemnt: string) => {
    let dataEleme: any = [];
    let dataSignal = list[elemnt];
    let userEntry = selectedList[elemnt];
    if (list?.hasOwnProperty(elemnt) && dataSignal) {
      dataSignal?.forEach((elemnent: any) => {
        if (Number(elemnent?.min) >= Number(userEntry?.min) && Number(elemnent?.max) <= Number(userEntry?.max)) {
          dataEleme.push(elemnent)
        }
      })
      if (dataEleme?.length > 0) {
        const totalCount = dataSignal?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0);
        const currentCount = dataEleme?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0)
        const outOfRangeCount = totalCount - currentCount;
        const element = {
          Count: outOfRangeCount,
          CountPerc: (outOfRangeCount / totalCount) * 100,
          min: dataEleme?.reduce((min: any, item: any) => Math.min(min, item.min), Infinity),
          max: dataEleme?.reduce((min: any, item: any) => Math.max(min, item?.max), 0),
        }
        dataList[elemnt] = [{ ...element }]
      } else {
        const totalCount = dataSignal?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0);
        const element = {
          Count: totalCount,
          CountPerc: 100,
          min: Number(userEntry?.min),
          max: Number(userEntry?.max),
        }
        dataList[elemnt] = [{ ...element }]
      }
      dataSignal = [];
      userEntry = [];
      dataEleme = []
    }
  })
  for (const [key, values] of Object.entries<any>(dataList)) {
    if(values?.length > 1 || !values[0]?.CountPerc) {
      const totalCount = values?.reduce((sum: any, item: any) => Number(sum) + Number(item?.Count), 0);
      const element = {
        Count: totalCount,
        CountPerc: 100,
        min: values?.reduce((min: any, item: any) => Math.min(min, item.min), Infinity),
        max: values?.reduce((min: any, item: any) => Math.max(min, item?.max), 0),
      }
      dataList[key] = [{ ...element }]
    }
  }
  return dataList;
};

export const trimToTwoDecimalPlaces = (num: number) => {
  if (num % 1 !== 0) { // Check if the number has a decimal part
    return parseFloat(num.toFixed(2));
  }
  return num; // Return the number as is if it's an integer
};

export const getLatLongData = (list: any) => {
  let position: any = [];
  list?.forEach((item: any) => {
    const data = {
      lat: item?.latitude,
      lng: item?.longitude,
      data: item?.vins
    }
    position.push(data)
  })
  return position;
}

export const getLatLongPositionData = (list: any) => {
  let position: any = [];
  list?.forEach((item: any, index: number) => {
    const data = {
      id: index,
      position: [item?.latitude, item?.longitude],
      data: Array.isArray(item?.vins) && item?.vins?.length > 0 ? item?.vins[0] : item?.vin
    }
    position.push(data)
  })
  return position;
}

export const getMapRoadData = (list: any) => {
  let roadData: any = [];
  list?.forEach((item: any) => {
    if(item?.geometry) {
      const data = {
        geometry: getRoadLatlong(item?.geometry),
        toolTip: `MaxSpeed: ${item?.maxspeed || 'none'} Surface: ${item?.surface?.toUpperCase() || 'none'}`
      }
      roadData.push(data)
    }
  })
  return roadData;
}

export const getRoadLatlong = (latlong: any) => {
  if (latlong) {
    const regex = /\((-?\d+\.\d+ -?\d+\.\d+(?:, -?\d+\.\d+ -?\d+\.\d+)*)\)/g;
    const matches = [...latlong.matchAll(regex)];

    const coordinates = matches?.map(match => {
      return match[1]
        .split(', ')
        .map((coord: any) => {
          const [lon, lat] = coord && coord.length > 0 && coord.indexOf(' ') && coord.split(' ').map(Number);
          return [lat, lon];
        });
    }).flat();

    return coordinates;
  } else {
    return []
  }
}


export const faultDataTriggerMinMax = (signalSelected: any, minMaxList: any) => {
  let data: any;
  signalSelected?.forEach((item: string) => {
    if (minMaxList?.hasOwnProperty(item)) {
      const value = minMaxList[item];
      data = {
        ...data,
        [item]: [value.min, value.max]
      }
    }
  })
  return data;
}

export const extractDataGroup = (unnestedData: any, title: string) => {
  let value: any;
  unnestedData?.forEach((element: any) => {
    if (element?.title === title) {
      value = element.value;
    }
  })
  return value;
}

export const extractSelectedValues = (values: string[]) => {
  let selectedList: any = [];
  values?.forEach((item: string) => {
    const data = {
      label: item,
      value: item
    }
    selectedList.push(data)
  })
  return selectedList;
}

export const getSelectedList = (selectedOption: string, subFilterSelection?: any) => {
  let resultList: string[] = [];
  switch (selectedOption) {
    case "stateList":
      return resultList = stateList?.map(item => item.label);
    case "cityList":
      if (subFilterSelection && subFilterSelection?.State?.length > 0) {
        return resultList = getCityList(subFilterSelection?.State)
      }
      return resultList = cityList;
    case "zipcodeList":
      if (subFilterSelection && subFilterSelection?.State?.length > 0) {
        return resultList = getZipCodes(subFilterSelection?.State)
      }
      return resultList = zipCodeList;
    case "speedList":
      return resultList = speedList;
    case "surfaceList":
      return resultList = surfaceList;
  }
  return resultList;
}

export const getStateList = () => {
  return stateList?.map(item => item.label);
}

export const getZipCodes = (selected: string[]) => {
  let resultList: string[] = [];
  const stateCode = getStateCode(selected);
  stateCode?.forEach((item: string) => {
  cityZipList?.forEach((element: any) => {
    for (const [key, value] of Object.entries<any>(element)) {
      if(key === item && value && value?.zipCode) {
        resultList.push(...(value?.zipCode || []))
      }
    }
  })
})
  return resultList;
}

export const getZipCodesCity = (selected: string[]) => {
  let resultList: string[] = [];
  const stateCode = getStateCodeCity(selected);
  stateCode?.forEach((item: string) => {
    cityZipCodeList?.forEach((element: any) => {
    for (const [key, value] of Object.entries<any>(element)) {
      if(key === item && value) {
       selected?.forEach((item: string) => {
        if(value?.hasOwnProperty(item)) {
          resultList.push(...value[item])
        }
       })
      }
    }
  })
})
  return resultList;
}

export const getZipCodesCityWithStateName = (selected: any[], stateCodeValue: string[]) => {
  let resultList: string[] = [];
  const stateCode = getStateCode(stateCodeValue);
  stateCode?.forEach((item: any) => {
    cityZipCodeList?.forEach((element: any) => {
    for (const [key, value] of Object.entries<any>(element)) {
      if(key === item && value) {
       selected?.forEach((items: any) => {
        if(value?.hasOwnProperty(items?.city) && !containsSubarray(resultList, value[items?.city])) {
          return resultList.push(...value[items?.city])
        }
       })
      }
    }
  })
  })
  return resultList;
}

export function containsSubarray(arr: string[], subArr: string[]) {
  const arrString = arr?.join(',');
  const subArrString = subArr?.join(',');
  return arrString.includes(subArrString); // Check if arrString contains subArrString
}

export const getCityList = (selected: string[]) => {
  let resultList: string[] = [];
  const stateCode = getStateCode(selected);
  stateCode?.forEach((item: string) => {
  cityZipList?.forEach((element: any) => {
    for (const [key, value] of Object.entries<any>(element)) {
      if(key === item && value && value?.city) {
        return resultList.push(...(value?.city || []))
      }
    }
  })
})
  return resultList;
}

export const getStateCode = (selected: string[]) => {
  let stateCode: string[] = [];
  selected?.forEach(ele => {
    stateList?.forEach((item: StateList) => {
      if(item?.label === ele) {
        stateCode.push(item.code)
      }
    } )
  })
  return stateCode;
}

export const getStateCodeCity = (selected: string[]) => {
  let stateCode: string[] = [];
  selected?.forEach(ele => {
    cityZipList?.forEach((element: any) => {
      for (const [key, value] of Object.entries<any>(element)) {
        if(value?.city?.includes(ele)) {
          stateCode.push(key)
        }
      }
    })
  })
  return stateCode;
}

export const disableDoneBtn = (data: any, filterSelected: string) => {
  if(data) {
    if (data[filterSelected] && data[filterSelected]?.length > 0) {
      return false
    } else {
      return true
    }
  } else {
    return true;
  }
}

export const disableListItemBtn = (data: any, subFilterSelection: any) => {
  if(data) {
    if(data?.id === 'speed' || data?.id === 'surface') {
      if(subFilterSelection?.State?.length > 0 || subFilterSelection?.City?.length > 0 || subFilterSelection?.Zipcode?.length > 0) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  } 
}

export function getTokenExpireTime(token: string) {
  const arrayToken = token.split('.');
  const tokenPayload = JSON.parse(atob(arrayToken[1]));
  const date: any = new Date(tokenPayload?.exp * 1000);
  const currentDate: any = new Date();
  const differenceInMilliseconds: number = date?.getTime() - currentDate?.getTime();
  return differenceInMilliseconds;
}

export const claimIndicatorList = (header: any, data: any) => {
  if (data?.length > 0 && data![0].hasOwnProperty(header) && data![0]![header]) {
    const list  = data![0]![header];
    if(list?.length > 0) {
      return ['Y']
    } else {
      return ['N']
    }
  } else {
    return ['N']
  }
}

export const generateDropDownList = (signals: any, vinlist: any) => {
  let list: any = [];
  signals?.forEach((item: any, index: number) => {
      if(vinlist && vinlist![index]) {
        list.push(vinlist[index])
      } else {
        list.push({ dropdown1: [], dropdown2: [] })
      }
  })
  return list;
}

export const getTimeList = (data: any) => {
  let minTimestamp: any = [];  //min_timestamp
  let maxTimestamp: any = [];  //max_timestamp
  data?.forEach((item: any) => {
    if(item?.min_timestamp) {
      minTimestamp.push(item?.min_timestamp)
    }
    if(item?.max_timestamp) {
      maxTimestamp.push(item?.max_timestamp)
    }
  })
  return {
    minTimestamp: minTimestamp[0],
    maxTimestamp: maxTimestamp[0]
  }
}

export const selectedStringListValues = (list: string[][][]) => {
  let updatedList: string[] = [];
  list?.forEach((element: any) => {
    updatedList.push(isArrayOfArrayOfStrings(element) ? element[0][0] : element[0])
  })
  return updatedList;
}
export const isArrayOfArrayOfStrings = (arr: any) => {
  return Array.isArray(arr) && arr.every(item => Array.isArray(item) && item.every(innerItem => typeof innerItem === 'string'));
}